<template>
    <div class="relative" ref="container">
        <input
            :class="[inputClasses, {'error': error}]"
            :type="type"
            :readonly="readonly"
            v-model.lazy="value"
            @focus="focus"
            @blur="blur"
            ref="input"
        />

        <label
            @click="focus"
            :class="labelClasses"
            ref="placeholder"
        >
            {{ placeholder }}
        </label>
    </div>
</template>

<script>
import inputs from '@/Mixins/inputs.js';

export default {
    mixins: [inputs],

    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    }
};
</script>

<style scoped>
.error {
    @apply border-danger;
}
</style>
